import './flipping.scss';

import * as React from 'react';

import {DirectionValue} from '../../const';

interface Props {
  onBtnClick: (value: DirectionValue) => void;
  isDisabled: boolean;
}

const Flipping = (props: Props) => {
  const {onBtnClick, isDisabled} = props;
  return (
    <div className="flipping">
      <button className="flipping__btn flipping__btn--prev"
        onClick={() => onBtnClick(DirectionValue.NEXT)}
        disabled={isDisabled}
      ><span className="visually-hidden">Prev</span></button>
      <button className="flipping__btn flipping__btn--next"
        onClick={() => onBtnClick(DirectionValue.PREV)}
        disabled={isDisabled}
      ><span className="visually-hidden">Next</span></button>
    </div>
  );
};

export default Flipping;
